/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type models_EmailHoldRule = {
    condition?: string;
    enabled?: boolean;
    id: string;
    name: string;
    type: models_EmailHoldRule.type;
};
export namespace models_EmailHoldRule {
    export enum type {
        AMOUNT_DEVIATION = 'amount_deviation',
        NEW_CONTRACT = 'new_contract',
        FIRST_INVOICE = 'first_invoice',
        MANUAL_HOLD = 'manual_hold',
        AMOUNT_THRESHOLD = 'amount_threshold',
        SETTLING_IN = 'settling_in',
    }
}

